export enum JobDetailsNavigationSource {
  JobBoard = 'job-board',
  PremiumLandingPage = 'premium_landing_page',
  Blog = 'blog',
}
